import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";

import { text_truncate } from "../../helpers";
import { ShortTeamsData } from "./types";
import TeamLogo from "./TeamLogo";

interface CustomersSidebarProps {
  items: ShortTeamsData[];
  pinnedItems?: ShortTeamsData[];
  activeId: string | number | undefined;
  tab: string;
}

const SidebarItem = ({
  team,
  activeId,
  tab,
}: {
  team: ShortTeamsData;
  activeId: string | number | undefined;
  tab: string;
}) => (
  <Link to={{ pathname: "/customers/" + team.teamId + "/" + tab }}>
    <Nav.Item
      className="customer-list-nav"
      style={
        team.teamId === activeId
          ? { backgroundColor: "#FFFFFF", fontWeight: "bold", color: "#007CB0" }
          : {}
      }
    >
      <TeamLogo abbr={team.teamAbbrName} />
      {`${team.teamAbbrName} ${text_truncate(team.teamNick, 14)}`}
    </Nav.Item>
  </Link>
);

export default ({
  items,
  pinnedItems = [],
  activeId,
  tab,
}: CustomersSidebarProps) => {
  return (
    <div className="customer-tab">
      {pinnedItems.length > 0 && (
        <>
          <Nav variant="pills" className="flex-column">
            {pinnedItems.map((team) => (
              <SidebarItem
                key={"nav-item-pinned-" + team.teamId}
                team={team}
                activeId={activeId}
                tab={tab}
              />
            ))}
          </Nav>
          <hr style={{ margin: 0, borderColor: "#CECECE" }} />
        </>
      )}
      <div className={"customer-tab-scroll"}>
        <Nav variant="pills" className="flex-column h-customer">
          {items.map((team) => (
            <SidebarItem
              key={"nav-item-" + team.teamId}
              team={team}
              activeId={activeId}
              tab={tab}
            />
          ))}
        </Nav>
      </div>
    </div>
  );
};
